'use strict';
const observable = require('../util/observable'),
	content = require('./content');
module.exports = function ActiveContentProvider() {
	let activeContent,
		localSessionId;

	const self = observable(this),
		onChanged = function (method, attrs, session) {
			self.dispatchEvent('mm-active-content-changed', activeContent, false, method, attrs);
			if (session === localSessionId || (!session && !localSessionId)) {
				self.dispatchLocalContentEvent({cmd: method, args: attrs});
			}
		};
	self.triggerRemoteContentEvent = function (contentEvent, sessionId) {
		activeContent.execCommand(contentEvent.cmd, contentEvent.args, sessionId);
		self.dispatchEvent('remoteContentEvent', contentEvent, sessionId);
	};
	self.getLocalSessionId = function () {
		return localSessionId;
	};
	self.setLocalSessionId = function (sessionId) {
		try {
			activeContent.setSessionKey(sessionId);
		} catch (e) {
			console.log('error', e); //eslint-disable-line
		}
		localSessionId = sessionId;
	};
	self.initializeSession = function (sessionId, initialContent, initialEvents) {
		const json = typeof initialContent === 'string' ? JSON.parse(initialContent) : JSON.parse(JSON.stringify(initialContent));
		if (activeContent) {
			activeContent.removeEventListener('changed', onChanged);
		}
		localSessionId = sessionId;

		activeContent = content(json, localSessionId);
		initialEvents.forEach((contentEvent) => {
			const sessionKey = contentEvent.collaborator && contentEvent.collaborator.sessionId || 'loading';
			activeContent.execCommand(contentEvent.cmd, contentEvent.args, sessionKey);
		});
		activeContent.addEventListener('changed', onChanged);
		self.dispatchEvent('newSession', activeContent, sessionId, initialContent, initialEvents);
		self.dispatchEvent('mm-active-content-changed', activeContent, true);
	};
	self.dispatchLocalContentEvent = function (event) {
		self.dispatchEvent('localContentEvent', event);
	};
	self.error = function (errorType, errorMessage) {
		self.dispatchEvent('error', errorType, errorMessage);
	};
	self.getActiveContent = function () {
		return activeContent;
	};
	self.getActiveContentClone = function () {
		if (!activeContent) {
			return false;
		}
		return content(JSON.parse(JSON.stringify(activeContent)));
	};
	self.addListener = function (onActiveContentChanged) {
		if (activeContent) {
			onActiveContentChanged(activeContent, false);
		}
		self.addEventListener('mm-active-content-changed', onActiveContentChanged);
	};
};

